/**
 * DocDB 模块接口列表
 */
 import $http from '../utils/http'; // 导入http中创建的axios实例

 const DocDB = {
    
    // 分页条件查询接口
    pagingQueryAwsDocDbCluster(params){
        return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAwsDocDbCluster`,params);
    },
    // 导出接口
    exportAwsDocDbCluster(params){
        return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsDocDbCluster`,params,{
            responseType: 'arraybuffer',
            timeout: 1000 * 60 * 20
        });
    },
    // 更新eks接口
    updateResource(params){
        return $http.post(`${global.API_URL}/sme/resourceManagement/updateResource`,params);
    },
    // 1. 以上是 DocDB管理界面

    // 2. DocDB监控界面
    // 2.  /sme/documentDBCluster/page  DocDB列表分页接口
    // 3. /sme/documentDBCluster/details DocDB列表点击详情接口
    // 所有查看监控概览接口  /sme/cloudWatch/checkDocumentDBMetricIndex
    // /sme/documentDBCluster/delete DocDB列表删除
    // 报警规则列表的分页接口 改参数：monitorModule：46 固定

    // 添加DocDB报警规则，有 monitorModule 统一改成 46 如果是实例是46，集群是47
    // 点击上一步里面的查询接口，后端会返回给我 monitorModule，然后前端把 monitorModule 传给
    // 点击下一步的接口，那些接口需要加 monitorModule

    // DOcDB列表筛选条件 增加集群标识符 input 框

    // /sme/documentDBCluster/queryAwsDocDbClusters  添加报警分页查询 上一步中的查询按钮

    // 添加时 实例选择下拉框传递 “实例” “集群” 不传 0 1 

     // DocDB列表分页接口
     documentDBClusterSelect(params){
        return $http.post(`${global.API_URL}/sme/documentDBCluster/page`,params);
    },
    // DocDB列表点击详情接口
    documentDBClusterDetail(params){
        return $http.post(`${global.API_URL}/sme/documentDBCluster/details`,params);
    },
    // DocDB列表删除
    documentDBClusterDelete(params){
        return $http.post(`${global.API_URL}/sme/documentDBCluster/delete`,params);
    },
    // 所有查看监控概览接口
    checkDocumentDBMetricIndex(params){
        return $http.post(`${global.API_URL}/sme/cloudWatch/checkDocumentDBMetricIndex`,params);
    },
    // 添加报警分页查询 上一步中的查询按钮
    queryAwsDocDbClusters(params){
        return $http.post(`${global.API_URL}/sme/documentDBCluster/queryAwsDocDbClusters`,params);
    },
 }
 
 export default DocDB;


// WEBPACK FOOTER //
// ./src/api/DocDB.js